<template>
  <div class="content-body">
    <div class="xinxi">
      <div class="title">
        查询条件
      </div>
      <el-select size="small" v-model="plan_id" placeholder="计划" style="width: 120px; margin-right: 10px;">
        <el-option :label="item.title" :value="item.plan_id" v-for="(item, index) in planLists" :key="index"></el-option>
      </el-select>
      <el-select size="small" v-model="group_id" placeholder="计划组" style="width: 120px; margin-right: 10px;">
        <el-option :label="item.group_name" :value="item.group_id" v-for="(item, index) in groupLists" :key="index"></el-option>
      </el-select>
      <el-select size="small" v-model="adv_id" placeholder="创意" style="width: 120px; margin-right: 10px;">
        <el-option :label="item.adv_title" :value="item.adv_id" v-for="(item, index) in advLists" :key="index"></el-option>
      </el-select>
      <el-button-group style="margin: 0 10px;">
        <el-button size="small" @click="dateType = 1" :type="dateType === 1 ? 'primary' : ''">今日</el-button>
        <el-button size="small" @click="dateType = 2" :type="dateType === 2 ? 'primary' : ''">本周</el-button>
        <el-button size="small" @click="dateType = 3" :type="dateType === 3 ? 'primary' : ''">本月</el-button>
      </el-button-group>
      <el-button size="small" type="primary" icon="el-icon-search" @click="drawLine()">查询</el-button>
    </div>

    <div class="xinxi">
      <div class="title">
        数据概览
      </div>
      <div class="adv-lists">
        <div class="one-lists">
          <div class="num" v-text="pay_money"></div>
          <div class="font">总花费</div>
        </div>
        <div class="one-lists">
          <div class="num" v-text="look_num"></div>
          <div class="font">点击量</div>
        </div>
        <div class="one-lists">
          <div class="num" v-text="read_num"></div>
          <div class="font">曝光量</div>
        </div>
      </div>
    </div>

    <div id="echarts-records" :style="{width: 'calc(100% - 100px)', height: '600px', marginLeft: '25px', marginTop: '10px'}"></div>

    <div class="table">
      <el-table ref="multipleTable" border :data="tableData" tooltip-effect="dark" style="width: calc(100% - 20px); margin-left: 10px;">
            <el-table-column prop="today" label="日期"></el-table-column>
            <el-table-column prop="read_num" label="曝光"></el-table-column>
            <el-table-column prop="look_num" label="点击"></el-table-column>
            <el-table-column prop="pay_money" label="支付"></el-table-column>
            <el-table-column prop="click_l" label="点击率"></el-table-column>
            <el-table-column prop="look_b" label="千次曝光成本"></el-table-column>
          </el-table>
      </div>
      <div class="page-c">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
          style="margin-left: 10px;">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from 'echarts';
export default {
  data() {
    return {
      dateType: 1,
      plan_id: '',
      planLists: [],
      group_id: '',
      groupLists: [],
      adv_id: '',
      advLists: [],
      pay_money: '-',
      look_num: '-',
      read_num: '-',
      tableData: [],
      page: 1,
      pageSize: 10,
      pageTotal: 1
    };
  },
  mounted() {
    this.$http.post('/trader/index/group_form').then(res => {
      if (res.code === 200) {
        this.planLists = res.data.plan_lists;
        this.drawLine();
        this.getData();
      }
    });
  },
  methods: {
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    },
    getData() {
      this.$http.post('/trader/data/getTableLists', {
        page: this.page,
        pageSize: this.pageSize
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = Math.ceil(res.count / this.pageSize);
          this.$function.hiddenLoading();
        }
      });
    },
    drawLine() {
      this.$http.post('/trader/data/getCount', {
        dateType: this.dateType,
        creativeId: this.adv_id,
        groupId: this.group_id,
        planId: this.plan_id
      }).then(res => {
        if (res.code === 200) {
          this.$function.hiddenLoading();
          this.pay_money = res.data.pay_money;
          this.look_num = res.data.look_num;
          this.read_num = res.data.read_num;

          // 填充数据表格
          const echartsRecords = echarts.init(document.getElementById('echarts-records'), 'walden');
          const option = {
            title: {
              text: '折线图堆叠'
            },
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['曝光', '点击', '支付']
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: res.chat.name
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: '支付',
                type: 'line',
                stack: '总量',
                data: res.chat.pay
              },
              {
                name: '点击',
                type: 'line',
                stack: '总量',
                data: res.chat.cpc
              },
              {
                name: '曝光',
                type: 'line',
                stack: '总量',
                data: res.chat.exposure
              }
            ]
          };
          echartsRecords.setOption(option);
        }
      });
    }
  },
  watch: {
    plan_id(newVal, oldVal) {
      this.$http.post('/trader/index/getGroupForPlanId', {
        plan_id: newVal
      }).then(res => {
        if (res.code === 200) {
          this.groupLists = res.data.group_lists;
          this.group_id = '';
          this.adv_id = '';
        }
      });
    },
    group_id(newVal, oldVal) {
      if (newVal !== '') {
        this.$http.post('/trader/data/getAdvLists', {
          group_id: newVal
        }).then(res => {
          if (res.code === 200) {
            this.advLists = res.data;
            this.adv_id = '';
          }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped="">
  .xinxi {
    width: calc(100% - 50px);
    margin-top: 10px;
    padding: 25px;
    .title {
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #221815;
      padding: 10px 0;
      margin-bottom: 10px;
      img {
        width: 18px;
        height: 18px;
        margin-right: 10px;
      }
    }
    .adv-lists {
      display: flex;
      margin-bottom: 20px;
      .one-lists {
        width: 150px;
        padding: 30px 50px;
        background: #fff;
        border-radius: 10px;
        text-align: center;
        margin-right: 10px;
        .num {
          font-size: 48px;
          font-weight: 500;
          color: #0056AF;
        }
        .font {
          margin-top: 10px;
          font-size: 14px;
          font-weight: 500;
          color: #221815;
        }
      }
    }
  }
  .other-data {
    display: flex;
    padding: 10px;
    .ios, .andriod {
      width: 50%;
    }
  }
  .page-c {
    background: #fff;
    padding: 20px 0;
  }
</style>
